import Image, { type ImageProps } from 'next/image';
import { cn } from '@/lib/utils';

type ThemeAwareLogoProperties = Omit<ImageProps, 'src'> & {
  lightSrc?: ImageProps['src'];
  darkSrc?: ImageProps['src'];
  wrapperClassName?: string;
  lightClassName?: string;
  darkClassName?: string;
  /**
   * When false, the component will not apply default visibility classes and consumers must handle
   * light/dark toggling themselves via `lightClassName`/`darkClassName`.
   */
  applyDefaultVisibilityClasses?: boolean;
};

export function ThemeAwareLogo({
  lightSrc: lightSource = '/assets/logo.png',
  darkSrc: darkSource = '/assets/logo-white.png',
  className,
  lightClassName,
  darkClassName,
  wrapperClassName,
  alt,
  applyDefaultVisibilityClasses = true,
  ...imageProperties
}: ThemeAwareLogoProperties) {
  const lightVisibility = applyDefaultVisibilityClasses ? 'dark:hidden' : undefined;
  const darkVisibility = applyDefaultVisibilityClasses ? 'hidden dark:inline-block' : undefined;

  return (
    <span className={cn('relative inline-flex items-center justify-center', wrapperClassName)}>
      <Image
        {...imageProperties}
        alt={alt}
        src={lightSource}
        className={cn(lightVisibility, className, lightClassName)}
      />
      <Image {...imageProperties} alt={alt} src={darkSource} className={cn(darkVisibility, className, darkClassName)} />
    </span>
  );
}
